import { Component, Input, Output, EventEmitter,OnInit,OnChanges,SimpleChange } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {SongDetailComponent} from '../../songs/song-detail/song-detail.component';
import {MdDialog, MdDialogRef} from '@angular/material';
import {PlayerService} from '../../player';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
@Component({
  selector: 'song-list-detail',
  templateUrl: './song-list-detail.component.html',
  styleUrls: ['./song-list-detail.component.css']
})
export class SongListDetailComponent implements OnInit, OnChanges{
  @Input() song: any;
  @Input() hideDownload = false;
  @Input() myMusicLibraryView = false;
  @Output() itemRemoved: EventEmitter<any> = new EventEmitter();
  dialogRef: MdDialogRef<SongDetailComponent>;
  public creditsArray: any = [];
  public writersArray: any = [];
  mobileView:boolean = false;
  private isThisSongPlaying: boolean = false;
  private songId: number = 0;
  private playerEventSubscriber = null;
  @BlockUI() blockUI: NgBlockUI;

  constructor(private activatedRoute: ActivatedRoute,private playerService: PlayerService,public dialog: MdDialog,) { }

  ngOnInit(){
    if(screen.width < 640){
     this.mobileView = true;
    }
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    this.songId = this.song.id;
    if (this.song._type === 'song') {
      this.isThisSongPlaying = this.playerService.getCurrentTrack() === this.songId;
      this.playerEventSubscriber = this.playerService.playerEvent.subscribe((event) => {
        if (event.type === 'track:id' && event.data === this.songId) {
          this.isThisSongPlaying = true;
        } else if (event.type === 'track:id' && event.data !== this.songId) {
          this.isThisSongPlaying = false;
        }
        if (this.isThisSongPlaying === true && event.type === 'music:isPlaying' && event.data === false) {
          this.isThisSongPlaying = false;
          this.song.isHovering = false;
        }
      });
    }
  }

  mouseHovering(index) {
    this.song.isHovering = true;
  }

  mouseLeaving(index) {
    this.song.isHovering = false;
  }

  itemRemovedEmit(event) {
    this.itemRemoved.emit({ removed: event.removed });
  }

  openSongDetail(event) {
    this.blockUI.start('Loading, please wait...');
    var width = '', height = '';
    var browserZoomLevel = Math.round(window.devicePixelRatio * 100);
    width = '37%';
    setTimeout(()=> {
      this.dialogRef = this.dialog.open(SongDetailComponent, {
        width: width
      });
      this.dialogRef.componentInstance.slug = this.song.slug;
      return false;
    }, 2000);
  }

}



// WEBPACK FOOTER //
// ./src/app/my-discoveries/song-list-detail/song-list-detail.component.ts